import React, { useRef } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { getUsersByIdApi } from "@/apis/apiCollection";
import { toast } from "@/apis/request";
import CompanyTree from ".";

export default function UserSelectModal({
  open,
  checkedKeys,
  multiple,
  footer,
  onSelect,
  onClose,
  onConfirm
}) {
  const tree = useRef(null);
  const { t } = useTranslation();

  const handleConfirm = async () => {
    const userIds = tree.current.getCheckedKeys();
    if (userIds.length === 0) {
      return toast.warning(t({ defaultMessage: "请至少勾选一个" }));
    }
    const { users } = await getUsersByIdApi({ user_ids: userIds });
    onConfirm?.(userIds, users);
    onClose?.();
  };

  return (
    <Modal
      onClose={onClose}
      onConfirm={handleConfirm}
      closeable
      open={open}
      width={576}
      title={t({ defaultMessage: "选择成员" })}
      footer={footer}
    >
      <CompanyTree
        checkable
        checkedKeys={checkedKeys}
        multiple={multiple}
        onSelect={onSelect}
        loadUsers
        ref={tree}
      />
    </Modal>
  );
}
